<template>
                    
    <transition name="fade">
        <q-btn v-if="!noShowBtnReset && form.isDirty" icon="undo" color="orange" square class="q-mr-sm"
                @click="reset()" />
    </transition>

    <!-- <q-space v-if="$q.screen.gt.xs" /> -->
    <q-space v-if="! buttonsLeft" />

    <JetActionMessage :on="form?.recentlySuccessful">
        <slot v-if="$slots.actions" name="actions"></slot>
        <span v-else>Enregistré.</span>
    </JetActionMessage>

    <!-- <small v-if="showAction && showAttestationHonneur && ! form.recentlySuccessful" class="text-grey q-mr-md">
        En validant ces données, vous certifiez sur l'honneur que celles-ci sont exactes.
    </small> -->

    <q-checkbox v-if="showAction && withContinueAction" label="Continuer" class="q-mr-sm"
                v-model="form.save_and_continue" />

    <transition name="bounce">
        <q-btn v-if="showAction"
                :disable="isProd && form.processing"
                :loading="isProd && form.processing"
                type="submit" icon="done" color="positive" square
                :label="buttonDoneText" />
    </transition>

</template>

<script setup>
import JetActionMessage from '@/Jetstream/ActionMessage.vue'

const props = defineProps({
    form: {Object, default: {}},
    'show-action': {Boolean, default: true},
    'with-continue-action': Boolean,
    'no-show-btn-reset': Boolean,
    'buttons-left': Boolean,
    'button-done-text': {String, default: ''},
})

const reset = ()=>{
    props.form.isDirty = false;

    if(_.isFunction(props.form.reset)){
        props.form.reset();
    }
}

</script>